import { css } from '@lastbrand/web-ui-styled-system/css'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

// Panda twin of the `.titleAndPriceSection_newDesignV2` block in BundleProductCard.module.scss.

export const titleAndPriceSectionCss = css({
  display: 'flex',
  justifyContent: 'space-between',
})

export const titleCss = css({
  textStyle: 'body-14',
  mb: 'space-4',
})

export const pricingCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  textStyle: 'body-14',
})

export const salePriceCss = css({
  fontWeight: 400,
})

export const salePriceBeforeBundleDiscountCss = css({
  fontWeight: 400,
  textDecoration: 'line-through',
  color: 'mediumgray',
})

export const checkboxAndTitleCss = css({
  display: 'flex',
  marginRight: 'space-20',
})

// Passed to web-ui's `css`/`labelCss` props, which take a raw SystemStyleObject, not a compiled class string.
export const checkboxWrapperStyle: SystemStyleObject = {
  marginTop: 'space-2',
}

export const checkboxLabelStyle: SystemStyleObject = {
  marginLeft: 'space-6',
}
